import Player from './player';
import User from './user';
import Puzzle from './puzzle';
import IDE from './ide';
import Video from './video';
import Points from './points';
import Quiz from './quiz';
import Pricing from './pricing';
import Checkout from './checkout';
import Problem from './problem';
import Dashboard from './dashboard';
import ProblemPoints from './problemPoints';
import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import Learning from './learning';

export default (history) => combineReducers({
    router: connectRouter(history),
    Player,
    User,
    Puzzle,
    IDE,
    Video,
    Points,
    Quiz,
    Pricing,
    Checkout,
    Problem,
    ProblemPoints,
    Dashboard,
    Learning,
});
